import React, { useEffect, useState } from "react";

import { DatetimeCustomEvent, IonDatetime, IonDatetimeButton, IonModal } from "@ionic/react";
import { v4 as uuidv4 } from "uuid";
import { debug } from "../../App";

export const DateField = (props: any) => {
  const [id] = useState(uuidv4());
  const [currentValue, setCurrentValue] = useState<string>(props.value ? new Date(props.value).toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" }) : props.default);

  function handleChange(event: DatetimeCustomEvent) {
    if (event.detail.value !== currentValue) {
      debug("Handling change on date", event);
      setCurrentValue(typeof event.detail.value === "undefined" ? "" : (event.detail.value as string));
    }
  }

  useEffect(() => {
    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: props.name,
        value: currentValue,
      },
    });
    props.onIonChange(ionEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentValue]);

  return (
    <>
      <IonModal keepContentsMounted={true}>
        <IonDatetime id={id} presentation={"date"} value={currentValue} onIonChange={handleChange} />
      </IonModal>

      <IonDatetimeButton datetime={id} />
    </>
  );
};
